/* global __THREEKIT_AUTH_TOKEN__,  __THREEKIT_HOST__, __THREEKIT_ORG__ */
import QRCode from 'qrcode';

import {
  THREEKIT_AUTH_TOKEN,
  THREEKIT_HOST,
  THREEKIT_ORG,
} from '../threekitEnv';

export const getSavedConfiguration = (configId) => {
  const url = `${THREEKIT_HOST}/api/configurations/${configId}?bearer_token=${THREEKIT_AUTH_TOKEN}`;

  return fetch(url, {
    method: 'get',
  })
    .then((res) => res.json())
    .catch((e) => console.error(e));
};

export const postConfiguration = (
  configuration,
  productVersion,
  assetId = window.threekit.api.assetId
) => {
  const url = `${THREEKIT_HOST}/api/configurations?bearer_token=${THREEKIT_AUTH_TOKEN}`;

  const body = new FormData();
  body.append('orgId', THREEKIT_ORG);
  body.append('productId', assetId);
  body.append('productVersion', productVersion);
  body.append('variant', JSON.stringify(configuration));

  return fetch(url, {
    method: 'post',
    body,
  }).then((res) => res.json());
};

// const AR_ASSET_ID = 'f40eee5b-0003-4e1f-a95d-4b560856b640';

export const exportAR = async ({ configuration, id, url }, productVersion) => {
  const { assetId } = window.threekit.api;

  if (typeof configuration === 'object') {
    Object.keys(configuration).forEach((key) => {
      if (/stealthtech/i.test(key)) {
        configuration[key] = 'off';
      } else {
        switch (key) {
          case 'Floor':
            configuration[key] = {};
            break;
          case 'Dimension':
            configuration[key] = 'off';
            break;
          case 'Rotation':
            configuration[key] = '0';
            break;
          default:
            break;
        }
      }
    });
  }

  const qrUrl = new URL(url || window.location.href);
  qrUrl.searchParams.append('enableAR', true);
  if (!(id && url)) {
    let configRes;
    let attempt = 0;
    let lastError;
    while (attempt < 3) {
      try {
        configRes = await postConfiguration(
          configuration,
          productVersion,
          assetId
        );
        break; // success
      } catch (err) {
        lastError = err;
        attempt++;
        if (attempt >= 3) {
          throw lastError;
        }
      }
    }

    const { shortId } = configRes;

    qrUrl.searchParams.append('tkcsid', shortId);
  } else qrUrl.search.append('tkcsid', id);

  const results = { url: qrUrl.toString() };

  results.dataURL = await QRCode.toDataURL(results.url);

  ['glb', 'usdz'].forEach((format) => {
    const exportURL = `${THREEKIT_HOST}/api/asset-jobs/${assetId}/export/${format}?bearer_token=${THREEKIT_AUTH_TOKEN}&cache=true`;
    results[format] = fetch(exportURL, {
      method: 'post',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        orgId: THREEKIT_ORG,
        assetId,
        sync: true,
        useCatalog: false,
        configuration,
        settings: { arExport: true },
      }),
    })
      .then((r) => r.json())
      .then((res) => {
        const fileObj = res.job?.runs[0]?.results?.files[0];
        if (fileObj) {
          const { id, name } = fileObj;
          return {
            name,
            url: `${THREEKIT_HOST}/api/files/${id}/content`,
          };
        }
      });
  });

  return results;
};
